import { Box, capitalize, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import { currencyFormatter, formatDatetime, nFormatter } from "../../../../../services";
import { STATUS_MAP } from "../../../constants";
import { COLORS } from "../../../../../theme/colors";

export function tenantListGroupRow(item, i, selectTenant) {
  return [
    <Typography noWrap key={i}>
      {
        <Box
          style={{
            cursor: "pointer",
            height: "20px",
            lineHeight: "20px",
            letter: "0.2 px",
            fontWeight: "bold",
          }}
          onClick={(e) => {
            selectTenant(e, i);
          }}
        >
          {item.expanded ? <span>- {item.name}</span> : <span>+ {item.name}</span>}
        </Box>
      }
    </Typography>,
    <Typography noWrap key={i}>
      {item.address}
    </Typography>,
    <Typography noWrap key={i} style={{ height: "24px", fontWeight: "bold" }}>
      {`${item.tenants?.length} tenants`}
    </Typography>,
  ];
}

export function tenantListRow(item, i, currencySymbol) {
  const mpan = item.mpans.join(", ");
  return [
    <Typography key={i}>{item.name}</Typography>,

    <Typography noWrap key={i}>
      {item?.unit_id?.toString()}
    </Typography>,
    nFormatter(item.square),
    <Box key={i}>
      <Typography
        style={{
          color: {
            CONNECTED: COLORS.green,
            READY_TO_CONNECT: COLORS.purple,
            STAND_BY: COLORS.darks[0][50],
          }[item.electricity_status?.status],
        }}
      >
        {STATUS_MAP[item.electricity_status?.status]}
      </Typography>
      {item.electricity_status?.status === "CONNECTED" ? (
        <Typography key={i}>
          Since {formatDatetime(item.electricity_status.since_connected, "MMM D, YYYY")}
        </Typography>
      ) : null}
    </Box>,
    <Typography key={i}>
      {mpan.length > 15 && item.mpans.length > 1 ? (
        <Tooltip title={mpan}>
          <Typography>{mpan.substring(0, 15) + "..."}</Typography>
        </Tooltip>
      ) : (
        mpan
      )}
    </Typography>,
    item.rent_per_month !== null
      ? currencyFormatter(item.rent_per_month, currencySymbol)
      : "No Data",
    formatDatetime(item.leasing_start, "MMM D, YYYY"),
    formatDatetime(item.leasing_end, "MMM D, YYYY"),
  ];
}

export const tenantListFormatter = (unitSystem) => {
  const headers = [
    "Tenant Name",
    "Unit",
    "Total " + capitalize(unitSystem),
    "Electricity status",
    "MPAN",
    "Rental/Mon",
    "Start Date",
    "Exp. Date",
  ];
  return {
    headers,
    groupColWidths: [12, 80, 8],
    colWidths: [13, 16, 6, 13, 17, 13, 11, 11],
    generateRow: tenantListRow,
    generateGroupRow: tenantListGroupRow,
  };
};
